import * as React from "react";
import { useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "./shared/header.js";
import Footer from "./shared/footer.js";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function Home() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;

  const [subscription, setSubscription] = React.useState([]);
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }
  useEffect(() => {
    // const token = getCookie("accessToken");
    // console.log(token);

    // if (!token) {
    //   console.log("Token not found");
    //   window.location.href = "/login";
    //   return;
    // }

    const fetchUserDetails = async () => {
      try {
        const token= localStorage.getItem("accessToken")
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };

        const response = await axios.get(GET_USER,config, {
          withCredentials: true, 
        });
        const { paymentDetails } = response.data.user;
        if (
          paymentDetails &&
          (paymentDetails.paymentStatus === "paid" ||
            paymentDetails.responseCode === "SUCCESS")
        ) {
          window.location.href = "/dashboard";
        } else {
          window.location.href = "/plans";
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchUserDetails();
  }, []);

 
  return <div></div>;
}
